import axios from "./axios";
const api = {};

api.login = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employee/login`;
  return axios.post(url, body);
};
api.logout = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employee/logout`;
  return axios.post(url, body);
};
api.forgetPass = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employee/forget-password`;
  return axios.post(url, body);
};
api.resetPass = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employee/reset-password`;
  return axios.post(url, body);
};
api.adminLogin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/login`;
  return axios.post(url, body);
};
api.verifyAdminSession = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/is-session-valid`;
  return axios.post(url, body);
};
api.uploadPDF = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/file/upload-pdf`;
  return axios.post(url, body);
};
api.addEmployee = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employees/add-employ`;
  return axios.post(url, body);
};
api.getEmployees = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employees`;
  return axios.get(url);
};
api.getDashboard = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employees/dashboard`;
  return axios.get(url);
};
api.getEmployee = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employees/${id}`;
  return axios.get(url);
};
api.verifyEmployeeSession = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employees/is-session-valid`;
  return axios.post(url, body);
};
api.addTask = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/tasks/add-task`;
  return axios.post(url, body);
};
api.editTask = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/tasks/edit-task`;
  return axios.post(url, body);
};
api.getTasks = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/tasks`;
  return axios.get(url);
};
api.loginEmployee = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employees/employ-login`;
  return axios.post(url, body);
};
api.getTasksByEmployee = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/tasks/task-by-employee`;
  return axios.post(url, body);
};
api.deleteEmployee = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employees/${id}`;
  return axios.delete(url);
};
api.deleteTask = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/tasks/${id}`;
  return axios.delete(url);
};
api.editEmployee = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employees/update-employee/${body._id}`;
  return axios.post(url, body);
};
api.addLeave = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/leaves/add-leaves`;
  return axios.post(url, body);
};
api.getAllLeaves = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/leaves/get-all-leaves`;
  return axios.post(url, body);
};
api.getEmployeeLeaves = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/leaves/employee/${id}`;
  return axios.get(url);
};
api.updateLeaves = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/leaves/update-status`;
  return axios.post(url, body);
};
api.markAttendance = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/attendance`;
  return axios.post(url, body);
};
api.markCheckout = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/attendance/${id}/checkout`;
  return axios.put(url, body);
};
api.getAllAttendance = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/attendance/`;
  return axios.get(url);
};

api.getEmployeeAttendance = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/attendance/employee/${id}`;
  return axios.get(url);
};
api.contactSubmit = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/contact/submit`;
  return axios.post(url, body);
};
api.contactGetAll = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/contact/get-all`;
  return axios.post(url, body);
};

export default api;
